import Flex from '@react-css/flex';
import Icon from 'storybookConfig/stories/molecules/Icon';
import styled from '@emotion/styled';
import Instagram from 'images/socials/instagram.svg';
import Facebook from 'images/socials/facebook.svg';
import Twitter from 'images/socials/x.svg';
import LinkedIn from 'images/socials/linkedin.svg';
import TikTok from 'images/socials/tiktok.svg';

const StyledLink = styled.a`
  color: ${({ theme }) => theme.color.gray700};

  &:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.color.gray700};
  }
`;

const IconContainer = styled.div`
  width: 30px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface SocialLinkProps {
  platform: string;
  url: string;
  iconOnly: boolean;
}

const socials = {
  website: {
    label: 'Website',
    icon: null,
  },
  instagram: {
    label: 'Instagram',
    icon: Instagram,
  },
  facebook: {
    label: 'Facebook',
    icon: Facebook,
  },
  twitter: {
    label: 'Twitter / X',
    icon: Twitter,
  },
  linkedIn: {
    label: 'LinkedIn',
    icon: LinkedIn,
  },
  tikTok: {
    label: 'Tiktok',
    icon: TikTok,
  },
};

const SocialLink = ({ platform, url, iconOnly }: SocialLinkProps) => {
  return (
    <StyledLink href={url} target="_blank" rel="noopener noreferrer">
      <Flex gap="12px" alignItems="center">
        <IconContainer>
          {platform === 'website' ? (
            <Icon name="link" size="24px" color="blue700" />
          ) : (
            <img
              src={socials[platform as keyof typeof socials]?.icon || ''}
              alt={`${platform} logo`}
              width="18"
              height="18"
            />
          )}
        </IconContainer>
        {!iconOnly && socials[platform as keyof typeof socials]?.label}
      </Flex>
    </StyledLink>
  );
};

export default SocialLink;
